var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{on:{"change":_vm.handleChange},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},_vm._l((_vm.sexOptions),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }